export const entity = {
	'title': `An entity is a piece of information or detail that gives context to the user's desired action or request.`,
	'sub-text-1': `"Can you help me order a pizza for dinner?"`,
	'sub-text-2': `"I'd like to get a large pepperoni pizza tonight"`,
}  

export const intent = {
	'title': `An intent signifies the desired outcome or activity a user aims to achieve. It embodies the objective or aim communicated in a user's statement.`
}  

